export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20product%20photography%20flatlay%20with%20coral%20pink%20sneakers%2C%20yellow%20backpack%2C%20mint%20green%20hoodie%2C%20and%20gold%20accessories%20arranged%20dynamically%20on%20white%20surface%2C%20bright%20energetic%20daylight%2C%20modern%20youthful%20lifestyle%20editorial%2C%20rich%20diverse%20color%20palette%2C%20playful%20creative%20composition%20with%20movement%20and%20energy&width=1800&height=800&seq=cta-bg-v2-2026&orientation=landscape"
          alt="Explore Hipobuy Spreadsheet resources"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
      </div>

      <div className="relative z-10 text-center px-6 md:px-10 max-w-2xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 tracking-wide mb-4">
          READY TO EXPLORE?
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-3 leading-relaxed">
          Thousands of organized product resources are waiting for you.
        </p>
        <p className="text-sm md:text-base text-background-50/70 mb-8 leading-relaxed">
          Jump into the most complete Hipobuy Spreadsheet database today.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer group"
        >
          <span className="w-8 h-8 rounded-full bg-background-50/20 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-background-50"></i>
          </span>
          <span>Explore Kaspreadsheet</span>
          <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}